import React, { useEffect, useState } from 'react';

import cn from 'classnames';
import { string, bool } from 'prop-types';

import { faFileCertificate } from '@fortawesome/pro-regular-svg-icons/faFileCertificate';

import Flexbox from 'components/Common/Flexbox';
import FontAwesomeIcon from 'components/Common/FontAwesomeIcon';

import s from './Placeholder.css';

const Placeholder = ({ width, height, isLoadingCredential }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!isLoadingCredential) {
      setIsVisible(true);
    }
  }, [isLoadingCredential]);

  return (
    <Flexbox
      justifyContent="center"
      alignItems="center"
      width={width}
      height={height}
      className={cn(s.placeholder, { [s.visible]: isVisible })}
    >
      <FontAwesomeIcon icon={faFileCertificate} color="grayDark" />
    </Flexbox>
  );
};

Placeholder.propTypes = {
  width: string,
  height: string,
  isLoadingCredential: bool,
};

Placeholder.defaultProps = {
  width: '100%',
  height: '100%',
  isLoadingCredential: true,
};

export default Placeholder;
